import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Appointment } from '../models/appointment.model';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class DataStoreService {
  private platformId = inject(PLATFORM_ID);

  private selectedBooking: Appointment | undefined;
  private bookingRecordKey = 'selected_booking_key';

  setBooking(booking: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedBooking = booking;
      sessionStorage.setItem(this.bookingRecordKey, JSON.stringify(booking));
    }
  }

  // @ts-ignore
  getBooking(): Appointment {
    if (this.selectedBooking) {
      return this.selectedBooking;
    }

    if (isPlatformBrowser(this.platformId)) {
      const booking = sessionStorage.getItem(this.bookingRecordKey);
      this.selectedBooking = booking ? JSON.parse(booking) : null;
    }
    return <Appointment>this.selectedBooking;
  }

  clearBooking() {
    sessionStorage.removeItem(this.bookingRecordKey);
  }
}
